var _defs, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.854,
    height: 57.854,
    viewBox: "0 0 57.854 57.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.927,57.854A28.927,28.927,0,1,1,57.854,28.927,28.927,28.927,0,0,1,28.927,57.854Z",
    fill: "#554886"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.927,57.854A28.927,28.927,0,1,1,57.854,28.927,28.927,28.927,0,0,1,28.927,57.854Z",
    fill: "#554886"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.559,
    cy: 28.559,
    r: 28.559,
    transform: "translate(0.368 0.368)",
    fill: "#544785"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.823 5.363)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.335,27.136,0,31.659v3.069H48.38l-17.406-8,2.878-4.591L25.7,6.467,21.1,1.362S17.543,0,17.269,0a50.65,50.65,0,0,0-3.837,3.837l1.712,8.36Z",
    transform: "translate(0 17.847)",
    fill: "#ffa787"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.609,18.248l4.934,3.838,1.642-3.062L5.538,0,0,5.777Z",
    transform: "translate(13.432 22.486)",
    fill: "#ffa787",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.983,24.373c-.181.012-.373.019-.577.022,0,0,1.165.891-.274,3.289l-.685,1.645L9.183,33.441,4.249,27.273.411,21.05,0,12.883V7.807l.822-2.05L2.467,3.015A38.335,38.335,0,0,1,5.893,0c.274,0,6.167,1.508,6.167,1.508l3.152,1.919.548,1.233c.092.274,1.764,5.048,2.87,8.205a5.784,5.784,0,0,1-.334,4.746l-.548.822s.507.635.661.787c1.02,1.268,2.766,3.685,1.783,4.284A10.921,10.921,0,0,1,17.983,24.373Z",
    transform: "translate(24.053 6.54)",
    fill: "#ffa787"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.645,12.689s-2.077,5.994,3.484,8.136l6.655,4.426a3.074,3.074,0,0,0,.626.321c1.4.524,6.559,2.217,6.914-1.1,0,0-.685-4.1.411-4.934l-1.919-.274s-.44,2.863-2.6,1.483a1.92,1.92,0,0,1-.872-1.412c-.157-1.438-.809-4.484-3.513-5a13.613,13.613,0,0,1-2.739-1.241A6.748,6.748,0,0,1,5.126,5.322L6.3,1.451S3.837.06,3.632,0,0,1.314,0,1.314L.411,3.781S3.015,5.562,1.645,12.689Z",
    transform: "translate(20.832 16.259)",
    fill: "#5e1212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.871,8.626s3.037,1.841,3.455-.738a3.324,3.324,0,0,0-1.57-3.338C26.738,2.075,14.939-3.993,6.532,3.966c0,0-5.956,4.608-5.962,9.346a23,23,0,0,1-.3,3.757C-.3,20.5-.5,26.618,5.366,26.717c0,0,1.782-9.114,7.264-9.662a33.7,33.7,0,0,0,3.282-1.178,5.24,5.24,0,0,0,3.174-5.294,8.659,8.659,0,0,1-.036-.886,2.985,2.985,0,0,1,2.965-2.941h0A11.633,11.633,0,0,1,28.871,8.626Z",
    transform: "translate(9.778 3.328)",
    fill: "#5e1212"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.265,1.949s-5.873-4.386-8.624,0c0,0-5.629,4.8-2.888,6.853,0,0,1.343,4.735,6.085,2.025L9.524,13.05l2.467-3.289L11.58,8.117C11.169,8.117,15.965,2.634,12.265,1.949Z",
    transform: "translate(6.1)",
    fill: "#5e1212"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.371,5.94a1.275,1.275,0,0,1-.577.022A.907.907,0,0,1,.04,4.8c0-.137,1.1-4.8,1.1-4.8s.173.193.43.5c.07.085.148.18.23.282C2.816,2.054,4.562,4.472,3.58,5.071A10.92,10.92,0,0,1,1.371,5.94Z",
    transform: "translate(40.665 24.974)",
    fill: "#ff8d69",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.893,11.1C3.66,11.1,0,7.127,0,4.591A4.343,4.343,0,0,1,4.043,0,4.343,4.343,0,0,1,8.086,4.591C8.086,7.127,8.126,11.1,5.893,11.1Z",
    transform: "translate(16.31 17.847)",
    fill: "#ffa787"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.42,4.888a4.769,4.769,0,0,0,.467.448L3.954,7.068A6.821,6.821,0,0,0,4.668,4.3a6.821,6.821,0,0,0-.483-2.818L3.922.824A1.31,1.31,0,0,0,2.347.05h0C.769.5-1.52,1.651,1.42,4.888Z",
    transform: "translate(17.837 19.825)",
    fill: "#ff8d69",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,5.619,11.65,0,30.974.685l17.405,8H0Z",
    transform: "translate(0 43.887)",
    fill: "#f98b91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7.125A2.8,2.8,0,0,0,.145,2.176,5.81,5.81,0,0,0,1.439,7.292s16.811,2.626,21.2-1.349Z",
    transform: "translate(8.339 38.629)",
    fill: "#f26c7f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.7.125A2.8,2.8,0,0,0,.145,2.176,5.81,5.81,0,0,0,1.439,7.292s16.811,2.626,21.2-1.349Z",
    transform: "translate(8.339 38.629)",
    fill: "#f3626b",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M.079,5.205a.206.206,0,0,1,.032-.344l.979-.507A6.21,6.21,0,0,0,2.665,3.326,3.035,3.035,0,0,0,3.382.271.206.206,0,1,1,3.771.14a3.455,3.455,0,0,1-.816,3.477,6.516,6.516,0,0,1-1.675,1.1L.3,5.226a.205.205,0,0,1-.222-.021Z",
    transform: "translate(11.116 27.851)",
    fill: "#5e1212"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M.288,2.433a.334.334,0,0,1-.276-.214.269.269,0,0,1,.147-.323.238.238,0,0,1,.309.093.205.205,0,0,1,.024.061,1.386,1.386,0,0,0,1.385-.824c.037-.092.068-.194.1-.3A1.243,1.243,0,0,1,2.6.015.206.206,0,1,1,2.752.4c-.209.086-.292.359-.38.648-.034.111-.069.226-.113.335A1.793,1.793,0,0,1,.62,2.467h0A1.626,1.626,0,0,1,.288,2.433Z",
    transform: "translate(10.525 28.3)",
    fill: "#5e1212"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.193,5.408A3.252,3.252,0,0,1,.528,4.361a1.945,1.945,0,0,1-.51-1.6A2.73,2.73,0,0,1,.911,1.437c.392-.39.762-.759.762-1.231A.206.206,0,0,1,1.879,0h0a.206.206,0,0,1,.206.205A2.234,2.234,0,0,1,1.2,1.728a2.4,2.4,0,0,0-.78,1.113A1.544,1.544,0,0,0,.843,4.1,2.839,2.839,0,0,0,2.3,5.01a.206.206,0,0,1-.051.4h0A.2.2,0,0,1,2.193,5.408Z",
    transform: "translate(7.907 3.777)",
    fill: "#c47076"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.808,7.9c-1.6-.2-3.119-.475-4.127-1.554a6.449,6.449,0,0,1-1.228-2.4,10.337,10.337,0,0,0-.617-1.522A4.86,4.86,0,0,0,1.253.684,1.063,1.063,0,0,0,.286.444.206.206,0,0,1,.125.066,1.428,1.428,0,0,1,1.481.341,5.271,5.271,0,0,1,3.2,2.226a10.633,10.633,0,0,1,.644,1.583,6.053,6.053,0,0,0,1.14,2.255C5.9,7.043,7.338,7.3,8.86,7.491a.206.206,0,0,1-.026.409h0Z",
    transform: "translate(28.851 30.878)",
    fill: "#c47076"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.392,4.343A6.183,6.183,0,0,1,3.839,3.207,12.6,12.6,0,0,1,2.513,2.063,6.368,6.368,0,0,0,.144.4.206.206,0,0,1,.266.009,6.767,6.767,0,0,1,2.8,1.764,12.3,12.3,0,0,0,4.078,2.872a5.768,5.768,0,0,0,3.315,1.06.206.206,0,0,1,0,.411h0Z",
    transform: "translate(28.26 36.38)",
    fill: "#c47076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.2cd738dc1d14a5aeeba7de1bb6a9431d.svg";
export { ForwardRef as ReactComponent };